var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unidata-editor"},[_c('div',{staticClass:"row"},[(_vm.bLoading)?_c('div',{staticClass:"animated fadeIn"},[_c('Loading',{attrs:{"active":true,"is-full-page":false}})],1):_vm._e(),_c('line-chart',{attrs:{"data":_vm.serie,"colors":_vm.colors,"xtitle":_vm.xTitle,"ytitle":_vm.yTitle,"download":true}})],1),_vm._m(0),_c('div',{staticClass:"row simply-editor"},[_c('div',{staticClass:"col-6 simply-item-container"},[_vm._v("\n      "+_vm._s(_vm.uniTranslation("GF45"))+"\n      "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"..."},model:{value:(_vm.chartType),callback:function ($$v) {_vm.chartType=$$v},expression:"chartType"}},_vm._l((_vm.availableCharts),function(chart){return _c('el-option',{key:chart.id,attrs:{"label":chart.title,"value":chart.id}})}),1)],1),_c('div',{staticClass:"col-2 simply-item-container"},[_vm._v("\n      "+_vm._s(_vm.uniTranslation("S1136"))+"\n      "),_c('VueAutonumeric',{staticClass:"form-control auto-numeric",staticStyle:{"text-align":"center !important"},attrs:{"options":{
          allowDecimalPadding: false,
          digitGroupSeparator: '',
          decimalCharacter: _vm.whatDecimalSeparator(),
          decimalCharacterAlternative: _vm.whatDecimalSeparatorAlternative(),
          decimalPlaces: 4,
          currencySymbol: '\u00a0€',
          currencySymbolPlacement: 's',
          roundingMethod: 'U',
          emptyInputBehavior: 'null',
          symbolWhenUnfocused: '',
          selectOnFocus: 'false',
          currencySymbol: '',
          negativePositiveSignPlacement: 'p'
        }},model:{value:(_vm.minValue),callback:function ($$v) {_vm.minValue=$$v},expression:"minValue"}})],1),_c('div',{staticClass:"col-2 simply-item-container"},[_vm._v("\n      "+_vm._s(_vm.uniTranslation("S1138"))+"\n      "),_c('VueAutonumeric',{staticClass:"form-control auto-numeric",staticStyle:{"text-align":"center !important"},attrs:{"options":{
          allowDecimalPadding: false,
          digitGroupSeparator: '',
          decimalCharacter: _vm.whatDecimalSeparator(),
          decimalCharacterAlternative: _vm.whatDecimalSeparatorAlternative(),
          decimalPlaces: 4,
          currencySymbol: '\u00a0€',
          currencySymbolPlacement: 's',
          roundingMethod: 'U',
          emptyInputBehavior: 'null',
          symbolWhenUnfocused: '',
          selectOnFocus: 'false',
          currencySymbol: '',
          negativePositiveSignPlacement: 'p'
        }},model:{value:(_vm.maxValue),callback:function ($$v) {_vm.maxValue=$$v},expression:"maxValue"}})],1),_c('div',{staticClass:"col-2 simply-item-container"},[_vm._v("\n      "+_vm._s(_vm.uniTranslation("GF30"))+"\n      "),_c('VueAutonumeric',{staticClass:"form-control auto-numeric",staticStyle:{"text-align":"center !important"},attrs:{"options":{
          allowDecimalPadding: false,
          digitGroupSeparator: '',
          decimalCharacter: _vm.whatDecimalSeparator(),
          decimalCharacterAlternative: _vm.whatDecimalSeparatorAlternative(),
          decimalPlaces: 4,
          currencySymbol: '\u00a0€',
          currencySymbolPlacement: 's',
          roundingMethod: 'U',
          emptyInputBehavior: 'null',
          symbolWhenUnfocused: '',
          selectOnFocus: 'false',
          currencySymbol: '',
          negativePositiveSignPlacement: 'p'
        }},model:{value:(_vm.stepValue),callback:function ($$v) {_vm.stepValue=$$v},expression:"stepValue"}})],1)]),(_vm.invalidData)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center !important"}},[_c('p',{staticStyle:{"color":"red","width":"100%"}},[_vm._v("\n      "+_vm._s(_vm.uniTranslation("ZZ0007"))+"\n    ")])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('hr')])
}]

export { render, staticRenderFns }